'use strict';

/**
 * Tests a provided value against a ValueType
 */
const testValueType = (v) => (type) => type.test(v);

exports.testValueType = testValueType;
//# sourceMappingURL=test.cjs.map
